import React, { useState, useEffect } from 'react';
import { Button, Modal, Progress, message, Tooltip, Space } from 'antd';
import { Form, InputGroup, Badge, Table } from 'react-bootstrap';
import {
    PlusOutlined,
    EditOutlined,
    DeleteOutlined,
    EyeOutlined,
    WhatsAppOutlined,
    ShareAltOutlined,
    LoginOutlined,
    ExperimentOutlined,
    CompassOutlined
} from '@ant-design/icons';
import { Select, DatePicker, Input } from 'antd';
import { useNavigate } from 'react-router-dom';
import { formatUrlString, encryptId, getuserdata, loginapi } from '../../services/apiService';
import axios from 'axios';
import { oneKlicks, sendWhatsApp } from '../../SDK/oneclick';
import { OneKlicksFileSDK } from '../../SDK/OneKlicksFileSDK';
import ImageShow from '../../Uitiles/ImageShow';
import decodeHtml from '../../Uitiles/decodeHtml';
import { debugLog } from '../../utils/debug';
import Paginationnew from '../../Uitiles/Paginationnew';
import { toast } from 'react-toastify';
import { useAuth } from '../../context/AuthContext';
import { UploadOutlined } from '@ant-design/icons';
import AddInvoiceModel from './Components/AddInvoiceModel';
import FetchBloodBankMapModal from './Components/FetchBloodBankMapModal';
import { read, utils } from 'xlsx';
import { useJsApiLoader } from '@react-google-maps/api';

const { TextArea } = Input;

const Diagnostics = () => {
    const navigate = useNavigate();
    const { login } = useAuth();
    const [searchText, setSearchText] = useState('');
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [usertype, setUsertype] = useState('');
    const [showPackageModal, setShowPackageModal] = useState(false);
    const [selectedLabForPackage, setSelectedLabForPackage] = useState(null);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(20);
    const [totalPages, setTotalPages] = useState(0);

    const [callStatusOptions] = useState([
        { value: 'Reschedule', label: 'Reschedule' },
        { value: 'Not Respond', label: 'Not Respond' },
        { value: 'Wrong Number', label: 'Wrong Number' },
        { value: 'Not Interested', label: 'Not Interested' },
        { value: 'Not Answered', label: 'Not Answered' },
    ]);
    const [callStatusValue, setCallStatusValue] = useState(null);
    const [callStatusModelshow, setCallStatusModelshow] = useState(false);
    const [selectedLabForCallStatus, setSelectedLabForCallStatus] = useState(null);
    const [callRemarks, setCallRemarks] = useState('');

    useEffect(() => {
        getDiagnostics();
    }, [searchText, page]);

    const getDiagnostics = async () => {
        try {
            setLoading(true);
            const tableSchema = '';
            const tableName = 'diagnostics';
            const conditions = {};
            const orderBy = 'id DESC';
            const search = {
                ...searchText && {
                    display_name: searchText,
                    phone: searchText,
                    id: searchText
                }
            };

            const pagination = {
                page: page,
                limit: limit
            };
            const margedata = [
                {
                    target_table: "user_package",
                    target_column: "user_id",
                    target_value: "id",
                    target_label: "user_package",
                    margedata: [
                        {
                            target_table: "packages",
                            target_column: "id",
                            target_value: "package_id",
                            target_label: "package_details"
                        }
                    ]
                },
            ];

            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);

            if (!response || !response.data) {
                throw new Error('Invalid response from server');
            }

            setData(response.data);
            setTotalPages(response.totalPages);
            setUsertype(await getuserdata('user_type'));
        } catch (error) {
            console.error('getDiagnostics error:', error);
            message.error('Failed to fetch diagnostics/labs');
            setData([]);
        } finally {
            setLoading(false);
        }
    };

    const handleLoginAs = async (record) => {
        const persintuser = await getuserdata('full');
        localStorage.setItem('presentuser', JSON.stringify(persintuser));
        localStorage.setItem('redirect_url_admin', '/superadmin/medical-labs');

        if (!record.email || record.email === "") {
            const randomNumber = Math.floor(1000 + Math.random() * 9000);
            const createemail = `${record.display_name.replace(/\s+/g, '').toLowerCase()}${Date.now()}${randomNumber}@meddylist.com`;
            await oneKlicks.update('', 'diagnostics', { email: createemail }, { id: record.id });
            record.email = createemail;
        }

        const loginResponse = await loginapi(record.email, record.pass, true);
        const user = loginResponse.data[0];

        if (user) {
            if (user.status === "2") {
                toast.error("Account deleted");
                return;
            }
            const userData = {
                id: user.id,
                email: user.email,
                user_type: user.user_type,
                display_name: user.display_name || user.email
            };
            const loginSuccess = await login(userData);
            if (loginSuccess) {
                toast.success("Logged in as Medical Lab user");
                navigate("/diagnostic/dashboard");
            }
        }
    };

    const [editModalVisible, setEditModalVisible] = useState(false);
    const [editingLab, setEditingLab] = useState(null);
    const [editFormData, setEditFormData] = useState({});
    const [uploading, setUploading] = useState(false);

    const handleEdit = (record) => {
        setEditingLab(record);
        setEditFormData({ ...record });
        setEditModalVisible(true);
    };

    const handleEditSave = async () => {
        try {
            setLoading(true);

            let lat = editFormData.lat;
            let lng = editFormData.lng;
            let photourl = editFormData.photourl;

            // If address changed or lat/lng missing, re-geocode
            if (editFormData.address !== editingLab.address || !lat || !lng) {
                const enriched = await geocodeAddress(editFormData.address);
                if (enriched.lat) {
                    lat = enriched.lat;
                    lng = enriched.lng;
                    if (!photourl && enriched.photo && enriched.photo.startsWith('http')) {
                        console.log("Internalizing geocoded photo during edit...");
                        const uploadRes = await OneKlicksFileSDK.uploadFileFromUrl('diagnostics', 'public', enriched.photo);
                        if (uploadRes && (uploadRes.fileid || uploadRes.fileId)) {
                            photourl = uploadRes.fileid || uploadRes.fileId;
                        } else {
                            photourl = enriched.photo;
                        }
                    }
                }
            }

            const updateData = {
                display_name: editFormData.display_name || '',
                phone: editFormData.phone || '',
                email: editFormData.email || '',
                address: editFormData.address || '',
                description: editFormData.description || '',
                photourl: photourl || '',
                lat: lat || '',
                lng: lng || '',
                call_status: editFormData.call_status || '',
                call_remarks: editFormData.call_remarks || ''
            };

            const response = await oneKlicks.update('', 'diagnostics', updateData, { id: editingLab.id });
            if (response.success) {
                message.success('Diagnostic/Lab updated successfully');
                setEditModalVisible(false);
                getDiagnostics();
            } else {
                message.error(response.message || 'Failed to update');
            }
        } catch (error) {
            console.error('Edit save error:', error);
            message.error('Failed to update diagnostic/lab');
        } finally {
            setLoading(false);
        }
    };

    const handleAddNew = () => {
        // Navigate to register screen with diagnostic type and admin_add flag
        navigate("/authentication?type=diagnostic&admin_add=true");
    };

    const handleFileUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        try {
            setUploading(true);
            const response = await OneKlicksFileSDK.uploadFile('diagnostics', 'public', file);
            if (response && (response.fileId || response.fileid)) {
                setEditFormData({ ...editFormData, photourl: response.fileId || response.fileid });
                message.success('Image uploaded successfully');
            } else {
                message.error('Upload failed');
            }
        } catch (error) {
            message.error('Error uploading file');
        } finally {
            setUploading(false);
        }
    };

    const handleDelete = async (record) => {
        if (window.confirm(`Are you sure you want to delete "${decodeHtml(record.display_name)}"?`)) {
            try {
                const response = await oneKlicks.delete('', 'diagnostics', { id: record.id });
                if (response && response.success) {
                    message.success('Diagnostic/Lab deleted successfully');
                    getDiagnostics();
                }
            } catch (error) {
                message.error('Failed to delete diagnostic/lab');
            }
        }
    };

    const handleStatusToggle = async (record) => {
        try {
            const newStatus = record.status == 1 ? 0 : 1;
            const response = await oneKlicks.update('', 'diagnostics', { status: newStatus }, { id: record.id });
            if (response && response.success) {
                message.success('Status updated');
                getDiagnostics();
            }
        } catch (error) {
            message.error('Failed to update status');
        }
    };

    const handleShareWhatsApp = (record) => {
        const url = `https://tech2day.co.in/diagnostic/${record.slug || record.id}`;
        const whatsappMsg = `Check out this Diagnostic/Lab: ${record.display_name}\nLink: ${url}`;
        sendWhatsApp(record.phone, whatsappMsg);
    };

    const openCallStatusModal = (lab) => {
        setSelectedLabForCallStatus(lab);
        setCallStatusValue(lab.call_status);
        setCallRemarks(lab.call_remarks || '');
        setCallStatusModelshow(true);
    };

    const handleSaveCallStatus = async () => {
        if (!selectedLabForCallStatus) return;
        try {
            const payload = {
                call_status: callStatusValue,
                call_remarks: callRemarks
            };
            const response = await oneKlicks.update('', 'diagnostics', payload, { id: selectedLabForCallStatus.id });
            if (response.success) {
                message.success('Call status updated');
                setCallStatusModelshow(false);
                getDiagnostics();
            }
        } catch (error) {
            message.error('Failed to update call status');
        }
    };

    const openPackageModal = (lab) => {
        setSelectedLabForPackage(lab);
        setShowPackageModal(true);
    };

    const [mapModalVisible, setMapModalVisible] = useState(false);
    const fileInputRef = React.useRef(null);
    const [importing, setImporting] = useState(false);

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
        libraries: ['places'] // Ensure libraries are loaded
    });

    const geocodeAddress = async (address) => {
        if (!isLoaded || !window.google) {
            console.error("Google Maps API not loaded");
            return { lat: null, lng: null, photo: null };
        }

        return new Promise((resolve) => {
            const geocoder = new window.google.maps.Geocoder();

            geocoder.geocode({ address: address }, (results, status) => {
                if (status === 'OK' && results && results.length > 0) {
                    const location = results[0].geometry.location;
                    const lat = location.lat();
                    const lng = location.lng();

                    const service = new window.google.maps.places.PlacesService(document.createElement('div'));
                    const request = {
                        location: location,
                        radius: '100',
                        query: address
                    };

                    service.textSearch(request, (placeResults, placeStatus) => {
                        let photoUrl = null;
                        if (placeStatus === window.google.maps.places.PlacesServiceStatus.OK && placeResults && placeResults[0]) {
                            const place = placeResults[0];
                            if (place.photos && place.photos.length > 0) {
                                photoUrl = place.photos[0].getUrl({ maxWidth: 800, maxHeight: 600 });
                            }
                        }
                        resolve({ lat: lat.toString(), lng: lng.toString(), photo: photoUrl });
                    });
                } else {
                    console.warn(`Geocode failed for ${address}: ${status}`);
                    resolve({ lat: null, lng: null, photo: null });
                }
            });

            // Timeout safety
            setTimeout(() => resolve({ lat: null, lng: null, photo: null }), 5000);
        });
    };

    const handleImportClick = () => {
        fileInputRef.current.click();
    };

    const handleExcelFileChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setImporting(true);
        const reader = new FileReader();

        reader.onload = async (evt) => {
            try {
                const bstr = evt.target.result;
                const wb = read(bstr, { type: 'binary' });
                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];
                const data = utils.sheet_to_json(ws);

                if (data.length === 0) {
                    toast.error("Excel file is empty");
                    setImporting(false);
                    return;
                }

                let successCount = 0;
                let failCount = 0;

                toast.info(`Processing ${data.length} records. This may take a moment due to geocoding...`);

                for (const row of data) {
                    try {
                        if (!row.Name && !row.name && !row.display_name) continue;

                        const displayName = row.Name || row.name || row.display_name;
                        let email = row.Email || row.email;
                        const phone = row.Phone || row.phone;
                        const address = row.Address || row.address;
                        const description = row.Description || row.description || '';
                        const password = "Ravindra12@";

                        let currentPhotoUrl = row.Image || row.PhotoUrl || row.photourl || row.profile_photo_url || row.ImageURL || row['Image URL'] || '';

                        // Parse Name
                        let firstName = row.FirstName || row.first_name || '';
                        let lastName = row.LastName || row.last_name || '';

                        const parts = displayName.trim().split(' ');
                        if (!firstName && parts.length > 0) {
                            firstName = parts[0];
                            lastName = parts.slice(1).join(' ');
                        }


                        // Parse Photo URL to get ID if it's a full URL
                        let finalPhotoId = currentPhotoUrl;
                        if (currentPhotoUrl && typeof currentPhotoUrl === 'string') {
                            const match = currentPhotoUrl.match(/\/file\/(\d+)/) || currentPhotoUrl.match(/^(\d+)$/);
                            if (match) {
                                finalPhotoId = match[1];
                            } else {
                                const digits = currentPhotoUrl.match(/(\d+)/g);
                                if (digits) {
                                    finalPhotoId = digits[digits.length - 1];
                                }
                            }
                        }

                        // Generate username (shortened)
                        const cleanNameForUser = displayName.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
                        const username = cleanNameForUser.substring(0, 15) + (Math.floor(Math.random() * 999));

                        // Generate email if missing
                        if (!email) {
                            email = `${username}@meddylist.import`;
                        }

                        // Geocode if address exists but lat/lng missing
                        let lat = row.Lat || row.lat;
                        let lng = row.Lng || row.lng;

                        console.log(`Row: ${displayName}, Lat: ${lat}, Lng: ${lng}, Address: ${address}`);

                        if ((!lat || !lng || !currentPhotoUrl) && address) {
                            console.log(`Geocoding address and fetching photo: ${address}`);
                            // Add small delay to avoid rate limiting
                            await new Promise(r => setTimeout(r, 200));
                            const enriched = await geocodeAddress(address);
                            console.log('Enrich result:', enriched);
                            if (enriched.lat) {
                                if (!lat) lat = enriched.lat;
                                if (!lng) lng = enriched.lng;
                                if (!currentPhotoUrl) currentPhotoUrl = enriched.photo;
                            }
                        }

                        if (currentPhotoUrl && typeof currentPhotoUrl === 'string' && currentPhotoUrl.startsWith('http')) {
                            console.log(`Internalizing image for ${displayName}: ${currentPhotoUrl}`);
                            const uploadRes = await OneKlicksFileSDK.uploadFileFromUrl('diagnostics', 'public', currentPhotoUrl);
                            if (uploadRes && (uploadRes.fileid || uploadRes.fileId)) {
                                finalPhotoId = uploadRes.fileid || uploadRes.fileId;
                                console.log(`Success: ${finalPhotoId}`);
                            } else {
                                console.warn(`Internalization failed for ${displayName}, using original URL`, uploadRes);
                                // Fallback is to keep photoUrl (handled by ImageShow if it was an ID, or raw URL)
                            }
                        }

                        const commonData = {
                            display_name: displayName.trim(),
                            username: username,
                            first_name: firstName,
                            last_name: lastName,
                            phone: phone ? String(phone).trim() : '',
                            address: address ? address.trim() : '',
                            description: description,
                            photourl: finalPhotoId,
                            lat: lat,
                            lng: lng
                        };

                        // Matching logic
                        let conditions = { email: email };
                        let existing = { success: false, data: [] };
                        if (email) {
                            existing = await oneKlicks.read('', 'diagnostics', conditions);
                        }

                        // If not found by email, try to find by Phone
                        if ((!existing.success || existing.data.length === 0) && phone) {
                            conditions = { phone: String(phone).trim() };
                            existing = await oneKlicks.read('', 'diagnostics', conditions);
                        }

                        // 3. Try exact match by Display Name
                        if (!existing.success || existing.data.length === 0) {
                            conditions = { display_name: displayName.trim() };
                            existing = await oneKlicks.read('', 'diagnostics', conditions);
                        }

                        // 4. Try Search by Name (Fuzzy fallback)
                        if (!existing.success || existing.data.length === 0) {
                            const searchObj = { display_name: displayName.trim() };
                            existing = await oneKlicks.read('', 'diagnostics', {}, 'id DESC', searchObj);
                        }

                        if (existing.success && existing.data.length > 0) {
                            const existingId = existing.data[0].id;
                            console.log(`Updating existing diagnostic ID: ${existingId}`);
                            Object.keys(commonData).forEach(key => {
                                if (commonData[key] === null || commonData[key] === undefined || commonData[key] === '') {
                                    delete commonData[key];
                                }
                            });
                            const updateRes = await oneKlicks.update('', 'diagnostics', commonData, { id: existingId });
                            if (updateRes.success) {
                                successCount++;
                            } else {
                                console.error(`Failed to update ${displayName}:`, updateRes);
                                failCount++;
                            }
                        } else {
                            console.log(`Creating new diagnostic: ${displayName}`);
                            const newData = {
                                ...commonData,
                                email: email,
                                pass: password,
                                status: '1',
                                user_type: 'diagnostic',
                                slug: displayName.toLowerCase().replace(/\s+/g, '-') + '-' + Math.floor(Math.random() * 1000)
                            };
                            const createRes = await oneKlicks.create('', 'diagnostics', newData);
                            if (createRes.success) {
                                successCount++;
                            } else {
                                console.error(`Failed to create ${displayName}:`, createRes);
                                failCount++;
                            }
                        }
                    } catch (err) {
                        console.error("Error importing row", row, err);
                        failCount++;
                    }
                }


                toast.success(`Import complete. Success: ${successCount}`);
                getDiagnostics();
            } catch (error) {
                console.error(error);
                toast.error("Failed to parse Excel");
            } finally {
                setImporting(false);
                e.target.value = null;
            }
        };
        reader.readAsBinaryString(file);
    };

    const handleMapImport = async (fetchedPlaces) => {
        setMapModalVisible(false);
        setLoading(true);
        let successCount = 0;
        let failCount = 0;

        try {
            for (const place of fetchedPlaces) {
                try {
                    // Generate unique email based on place_id or name
                    const possibleEmail = `${place.name.replace(/\s+/g, '').toLowerCase()}${place.place_id.substring(0, 4)}@google.import`;

                    const conditions = { email: possibleEmail };
                    const existing = await oneKlicks.read('', 'diagnostics', conditions);

                    if (existing.success && existing.data.length > 0) {
                        continue; // Skip if exists
                    }

                    let finalPhotoUrl = '';
                    if (place.address) {
                        const enriched = await geocodeAddress(place.address);
                        if (enriched.photo && enriched.photo.startsWith('http')) {
                            const uploadRes = await OneKlicksFileSDK.uploadFileFromUrl('diagnostics', 'public', enriched.photo);
                            if (uploadRes && (uploadRes.fileid || uploadRes.fileId)) {
                                finalPhotoUrl = uploadRes.fileid || uploadRes.fileId;
                            } else {
                                finalPhotoUrl = enriched.photo;
                            }
                        }
                    }

                    const newData = {
                        display_name: place.name,
                        email: possibleEmail,
                        phone: '',
                        address: place.address,
                        lat: place.position.lat,
                        lng: place.position.lng,
                        pass: "Ravindra", // User specific request
                        status: '1',
                        user_type: 'diagnostic',
                        slug: place.name.toLowerCase().replace(/\s+/g, '-') + '-' + Math.floor(Math.random() * 1000),
                        photourl: finalPhotoUrl,
                        photos: JSON.stringify(finalPhotoUrl ? [finalPhotoUrl] : [])
                    };

                    await oneKlicks.create('', 'diagnostics', newData);
                    successCount++;

                } catch (err) {
                    console.error("Error importing place", place, err);
                    failCount++;
                }
            }
            toast.success(`Google Map Import complete. Added: ${successCount}`);
            getDiagnostics();
        } catch (e) {
            console.error(e);
            toast.error("Error during import");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container-fluid py-4">
            <div className="card mb-4 border-0 shadow-sm">
                <div className="card-body p-4">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <h4 className="mb-1 fw-bold">
                                <ExperimentOutlined className="me-2" />
                                Diagnostics & Medical Labs Management
                            </h4>
                            <p className="text-muted mb-0">Manage and monitor diagnostic centers and medical laboratories</p>
                        </div>
                        <div className="col-md-6 text-md-end mt-3 mt-md-0">
                            <Space size="middle">
                                <InputGroup style={{ width: '300px' }}>
                                    <Form.Control
                                        placeholder="Search by name, phone, email..."
                                        value={searchText}
                                        onChange={(e) => setSearchText(e.target.value)}
                                        className="shadow-none"
                                    />
                                </InputGroup>
                                <Button
                                    type="primary"
                                    icon={<PlusOutlined />}
                                    onClick={handleAddNew}
                                    size="middle"
                                    className="d-flex align-items-center"
                                >
                                    Add New Lab
                                </Button>
                                <Button
                                    icon={<UploadOutlined />}
                                    onClick={handleImportClick}
                                    loading={importing}
                                    size="middle"
                                >
                                    Import Excel
                                </Button>
                                <Button
                                    icon={<CompassOutlined />}
                                    onClick={() => setMapModalVisible(true)}
                                    size="middle"
                                >
                                    Fetch from Map
                                </Button>
                                <input
                                    type="file"
                                    ref={fileInputRef}
                                    style={{ display: 'none' }}
                                    onChange={handleExcelFileChange}
                                    accept=".xlsx, .xls"
                                />
                            </Space>
                        </div>
                    </div>
                </div>
            </div>

            <div className="card border-0 shadow-sm">
                <div className="card-body p-0">
                    <div className="table-responsive">
                        <table className="table table-hover align-middle mb-0">
                            <thead className="bg-light text-muted text-uppercase" style={{ fontSize: '12px' }}>
                                <tr>
                                    <th className="px-4 py-3">Details</th>
                                    <th>Contact Info</th>
                                    <th>Call Status</th>
                                    <th>Current Package</th>
                                    <th>Status</th>
                                    <th className="text-end px-4">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan="6" className="text-center py-5">
                                            <Progress percent={100} status="active" showInfo={false} style={{ width: '200px' }} />
                                            <div className="mt-2">Loading diagnostics/labs...</div>
                                        </td>
                                    </tr>
                                ) : data.length > 0 ? (
                                    data.map((item) => (
                                        <tr key={item.id}>
                                            <td className="px-4 py-3">
                                                <div className="d-flex align-items-center">
                                                    <ImageShow
                                                        image={(() => {
                                                            if (item.photourl) return item.photourl;
                                                            try {
                                                                const photos = JSON.parse(item.photos || '[]');
                                                                if (Array.isArray(photos) && photos.length > 0) return photos[0];
                                                            } catch (e) { }
                                                            return '';
                                                        })()}
                                                        width={45}
                                                        height={45}
                                                        style={{ borderRadius: '8px', objectFit: 'cover' }}
                                                        className="shadow-sm bg-light"
                                                    />
                                                    <div className="ms-3">
                                                        <div className="fw-bold text-dark">{decodeHtml(item.name || item.display_name)}</div>
                                                        <small className="text-muted">ID: #{item.id}</small>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="d-flex flex-column" style={{ fontSize: '13px' }}>
                                                    <span className="mb-1"><i className="ti-headphone-alt me-2"></i>{item.phone || 'N/A'}</span>
                                                    <span className="text-muted"><i className="ti-location-pin me-2"></i>{item.address || 'Location N/A'}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <Button
                                                    size="small"
                                                    className="rounded-pill px-3"
                                                    onClick={() => openCallStatusModal(item)}
                                                    type={item.call_status ? "default" : "dashed"}
                                                >
                                                    {item.call_status || "Set Call Status"}
                                                </Button>
                                            </td>
                                            <td>
                                                <Badge
                                                    bg="light"
                                                    text="primary"
                                                    className="border cursor-pointer p-2"
                                                    onClick={() => openPackageModal(item)}
                                                >
                                                    {item.user_package?.[0]?.package_details?.[0]?.name || "Free Plan"}
                                                </Badge>
                                            </td>
                                            <td>
                                                <Badge
                                                    bg={item.status == 1 ? "success" : "danger"}
                                                    className="cursor-pointer px-3 py-2 rounded-pill"
                                                    onClick={() => handleStatusToggle(item)}
                                                >
                                                    {item.status == 1 ? 'Active' : 'Inactive'}
                                                </Badge>
                                            </td>
                                            <td className="text-end px-4">
                                                <Space size="small">
                                                    <Tooltip title="Edit Details">
                                                        <Button
                                                            shape="circle"
                                                            icon={<EditOutlined />}
                                                            onClick={() => handleEdit(item)}
                                                        />
                                                    </Tooltip>
                                                    <Tooltip title="Login as Lab">
                                                        <Button
                                                            shape="circle"
                                                            icon={<LoginOutlined />}
                                                            onClick={() => handleLoginAs(item)}
                                                        />
                                                    </Tooltip>
                                                    <Tooltip title="WhatsApp Share">
                                                        <Button
                                                            shape="circle"
                                                            icon={<WhatsAppOutlined />}
                                                            className="text-success border-success"
                                                            onClick={() => handleShareWhatsApp(item)}
                                                        />
                                                    </Tooltip>
                                                    <Tooltip title="Delete">
                                                        <Button
                                                            shape="circle"
                                                            danger
                                                            icon={<DeleteOutlined />}
                                                            onClick={() => handleDelete(item)}
                                                        />
                                                    </Tooltip>
                                                </Space>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="6" className="text-center py-5 text-muted">
                                            No diagnostic centers/labs found matching your search.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <div className="p-4 border-top">
                        <Paginationnew currentPage={page} totalPages={totalPages} handlePageChange={(p) => setPage(p)} />
                    </div>
                </div>
            </div>

            {/* Call Status Modal */}
            <Modal
                title="Update Call Status"
                open={callStatusModelshow}
                onCancel={() => setCallStatusModelshow(false)}
                onOk={handleSaveCallStatus}
                centered
                destroyOnClose
            >
                <div className="mb-4 mt-3">
                    <label className="form-label fw-bold">Call Outcome</label>
                    <Select
                        className="w-100"
                        placeholder="Select status"
                        options={callStatusOptions}
                        value={callStatusValue}
                        onChange={setCallStatusValue}
                        size="large"
                    />
                </div>
                <div className="mb-3">
                    <label className="form-label fw-bold">Follow-up Remarks</label>
                    <TextArea
                        rows={4}
                        placeholder="Enter any notes about the call..."
                        value={callRemarks}
                        onChange={(e) => setCallRemarks(e.target.value)}
                        className="rounded"
                    />
                </div>
            </Modal>

            {/* Edit Lab Modal */}
            <Modal
                title="Edit Diagnostic/Lab Details"
                open={editModalVisible}
                onCancel={() => setEditModalVisible(false)}
                onOk={handleEditSave}
                width={800}
                centered
                destroyOnClose
            >
                <div className="row g-3 p-2">
                    <div className="col-md-6">
                        <label className="form-label fw-bold">Display Name</label>
                        <Input
                            value={editFormData.display_name}
                            onChange={(e) => setEditFormData({ ...editFormData, display_name: e.target.value })}
                            placeholder="Enter display name"
                        />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label fw-bold">Phone</label>
                        <Input
                            value={editFormData.phone}
                            onChange={(e) => setEditFormData({ ...editFormData, phone: e.target.value })}
                            placeholder="Enter phone number"
                        />
                    </div>
                    <div className="col-md-12">
                        <label className="form-label fw-bold">Address</label>
                        <TextArea
                            rows={2}
                            value={editFormData.address}
                            onChange={(e) => setEditFormData({ ...editFormData, address: e.target.value })}
                            placeholder="Enter full address"
                        />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label fw-bold">Email</label>
                        <Input
                            value={editFormData.email}
                            onChange={(e) => setEditFormData({ ...editFormData, email: e.target.value })}
                            placeholder="Enter email"
                        />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label fw-bold">Profile Photo</label>
                        <div className="d-flex flex-column gap-2">
                            <div className="d-flex align-items-center gap-3">
                                <ImageShow image={editFormData.photourl} width={50} height={50} style={{ borderRadius: '8px' }} />
                                <input
                                    type="file"
                                    className="form-control"
                                    onChange={handleFileUpload}
                                    accept="image/*"
                                    disabled={uploading}
                                />
                            </div>
                            <div className="input-group">
                                <Input
                                    placeholder="Or paste an image URL here..."
                                    onPressEnter={async (e) => {
                                        const url = e.target.value.trim();
                                        if (url && url.startsWith('http')) {
                                            try {
                                                setUploading(true);
                                                const res = await OneKlicksFileSDK.uploadFileFromUrl('diagnostics', 'public', url);
                                                if (res && (res.fileid || res.fileId)) {
                                                    setEditFormData({ ...editFormData, photourl: res.fileid || res.fileId });
                                                    message.success('Image internalized from URL');
                                                    e.target.value = '';
                                                } else {
                                                    message.error('Failed to internalize image from URL');
                                                }
                                            } catch (err) {
                                                message.error('Error fetching image from URL');
                                            } finally {
                                                setUploading(false);
                                            }
                                        }
                                    }}
                                />
                                <Button
                                    onClick={async () => {
                                        const input = document.querySelector('input[placeholder="Or paste an image URL here..."]');
                                        const url = input.value.trim();
                                        if (url && url.startsWith('http')) {
                                            try {
                                                setUploading(true);
                                                const res = await OneKlicksFileSDK.uploadFileFromUrl('diagnostics', 'public', url);
                                                if (res && (res.fileid || res.fileId)) {
                                                    setEditFormData({ ...editFormData, photourl: res.fileid || res.fileId });
                                                    message.success('Image internalized from URL');
                                                    input.value = '';
                                                } else {
                                                    message.error('Failed to internalize image from URL');
                                                }
                                            } catch (err) {
                                                message.error('Error fetching image from URL');
                                            } finally {
                                                setUploading(false);
                                            }
                                        } else {
                                            message.warning('Please enter a valid HTTP URL');
                                        }
                                    }}
                                    loading={uploading}
                                >
                                    Upload URL
                                </Button>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <label className="form-label fw-bold">Call Status</label>
                        <Select
                            className="w-100"
                            placeholder="Select status"
                            options={callStatusOptions}
                            value={editFormData.call_status}
                            onChange={(val) => setEditFormData({ ...editFormData, call_status: val })}
                        />
                    </div>
                    <div className="col-md-12">
                        <label className="form-label fw-bold">Call Remarks</label>
                        <TextArea
                            rows={3}
                            value={editFormData.call_remarks}
                            onChange={(e) => setEditFormData({ ...editFormData, call_remarks: e.target.value })}
                            placeholder="Enter call remarks"
                        />
                    </div>
                    <div className="col-md-12">
                        <label className="form-label fw-bold">Description</label>
                        <TextArea
                            rows={3}
                            value={editFormData.description}
                            onChange={(e) => setEditFormData({ ...editFormData, description: e.target.value })}
                            placeholder="Enter description"
                        />
                    </div>
                </div>
            </Modal>

            <AddInvoiceModel
                showAdd={showPackageModal}
                setShowAdd={setShowPackageModal}
                mode="add"
                getdata={getDiagnostics}
                addbydocter={selectedLabForPackage}
            />

            <FetchBloodBankMapModal
                open={mapModalVisible}
                onCancel={() => setMapModalVisible(false)}
                onImport={handleMapImport}
                apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
                title="Fetch Diagnostics from Google Maps"
                defaultQuery="Diagnostic Centre"
            />
        </div>
    );
};

export default Diagnostics;
